__turbopack_context__.v({
  "className": "sfprodisplayheavy_871d94c-module__BRN1DW__className",
  "variable": "sfprodisplayheavy_871d94c-module__BRN1DW__variable",
});
